export default "__VITE_ASSET__z73cxg9p__"